import Assert from "tbAssert";
import ngSanitize from "angular-sanitize";
import ngAria from "angular-aria";
import ngAnimate from "angular-animate";
import uiRouterModule from "@uirouter/angularjs";

import TbAppConfigDataServiceModule from "../../config/tb-app-config/TbAppConfigDataService";
import tbAlertTypeFilterModule from "tbClient/filters/AlertTypeFilter";

const mWindowSvc = new WeakMap();
const mStateParams = new WeakMap();
const mErrorMessages = new WeakMap();
const mTbAppLocation = new WeakMap();

class ErrorPageController {
    constructor($window, $transition$, TbAppConfigDataService) {
        Assert.StrictAssert($window != null, "Assert Failure: Missing Window service dependency");
        Assert.StrictAssert($transition$ != null, "Assert Failure: Missing Transition Object Dependency");
        Assert.StrictAssert(TbAppConfigDataService != null, "Assert Failure: Missing TrackerBase App Config Data Service Dependency");

        mWindowSvc.set(this, $window);
        mErrorMessages.set(this, []);
        mStateParams.set(this, $transition$.params());
        mTbAppLocation.set(this, TbAppConfigDataService.tbClientAppUrl);
    }

    $onInit() {
        mErrorMessages.get(this).push("An error occurred while processing. Please reload the application, and contact support if the error happens again.");
    }

    get errorMessage() {
        return mErrorMessages.get(this)[0];
    }

    reloadApp() {
        const appLocation = mTbAppLocation.get(this);
        mWindowSvc.get(this).location.assign(appLocation);
    }
}

ErrorPageController.template = require("./ErrorPage.tpl.html");
ErrorPageController.controllerAs = "errorPageCtrl";

ErrorPageController.$inject = [
    "$window",
    "$transition$",
    "TbAppConfigDataService"
];

ErrorPageController.dependencies = [
    ngSanitize,
    ngAria,
    ngAnimate,
    uiRouterModule,
    TbAppConfigDataServiceModule,
    tbAlertTypeFilterModule
];

export default ErrorPageController;



//////////////////
// WEBPACK FOOTER
// ./src/views/error-page/ErrorPageController.js
// module id = z7u/
// module chunks = 1